/**
 * Auth Reducer
 *
 * Gestisce stato autenticazione utente con Laravel Sanctum
 */

export const AUTH_LOGIN_REQUEST = 'AUTH_LOGIN_REQUEST';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';

export const AUTH_REGISTER_REQUEST = 'AUTH_REGISTER_REQUEST';
export const AUTH_REGISTER_SUCCESS = 'AUTH_REGISTER_SUCCESS';
export const AUTH_REGISTER_FAILURE = 'AUTH_REGISTER_FAILURE';

export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const AUTH_LOAD_USER_SUCCESS = 'AUTH_LOAD_USER_SUCCESS';
export const AUTH_LOAD_USER_FAILURE = 'AUTH_LOAD_USER_FAILURE';

export const AUTH_UPDATE_PROFILE_SUCCESS = 'AUTH_UPDATE_PROFILE_SUCCESS';

export const AUTH_CLEAR_ERROR = 'AUTH_CLEAR_ERROR';

const initialState = {
  user: (() => {
    try {
      const stored = localStorage.getItem('auth_user');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  })(),
  token: localStorage.getItem('auth_token') || null,
  isAuthenticated: !!localStorage.getItem('auth_token'),
  loading: false,
  error: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {

    case AUTH_LOGIN_REQUEST:
    case AUTH_REGISTER_REQUEST:
      return { ...state, loading: true, error: null };

    case AUTH_LOGIN_SUCCESS:
    case AUTH_REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: action.payload.user,
        token: action.payload.token,
        error: null,
      };

    case AUTH_LOGIN_FAILURE:
    case AUTH_REGISTER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case AUTH_LOGOUT:
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
        error: null,
      };

    case AUTH_LOAD_USER_SUCCESS:
      return { ...state, user: action.payload, isAuthenticated: true };

    case AUTH_LOAD_USER_FAILURE:
      return { ...state, user: null, token: null, isAuthenticated: false };

    case AUTH_UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        user: action.payload,
      };

    case AUTH_CLEAR_ERROR:
      return { ...state, error: null };

    default:
      return state;
  }
};

export default authReducer;
